import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { LcsCallStatePipeModule } from '@lcs/shared/call-state-pipe';
import { FormFooterComponent } from './form-footer.component';

@NgModule({
   declarations: [FormFooterComponent],
   exports: [FormFooterComponent],
   imports: [CommonModule, MatButtonModule, LcsCallStatePipeModule],
})
export class FormFooterModule {}
